/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ReactElement } from 'react'
import { RoutesEnum } from '../../utils/routesEnum'
import Button from '../button'
import { Container } from './styles'

type CardPatientProps = {
  name?: string
  sex?: 'male' | 'female'
  age?: number | string
  imc?: number | string
  patientId?: string
  disabled?: boolean
  isLoading?: boolean
  onSave?: () => void
  onSearch?: (e: any) => void
}

const sexToValue = {
  male: 'Masculino',
  female: 'Feminino'
}

const CardPatient: FC<CardPatientProps> = ({
  name,
  sex,
  age,
  imc,
  patientId,
  disabled,
  isLoading,
  onSave,
  onSearch
}): ReactElement => {
  return (
    <Container>
      <h3>Dados paciente</h3>
      <div className='flex'>
        <div className='flex_inside'>
          <span className='label'>Nome</span>
          <span className='text'>{name || '-'}</span>
        </div>
        <div className='flex_inside'>
          <span className='label'>Sexo</span>
          <span className='text'>{sex && sexToValue[sex]}</span>
        </div>
      </div>
      <div className='flex'>
        <div className='flex_inside'>
          <span className='label'>Idade</span>
          <span className='text'>{age}</span>
        </div>
        <div className='flex_inside'>
          <span className='label'>IMC</span>
          <span className='text'>{imc}</span>
        </div>
      </div>
      <div className='buttons'>
        {patientId
          ? (
            <>
              <Button
                disabled={disabled}
                block
                size='sm'
                onClick={onSave}
                isLoading={isLoading}
              >
                SALVAR EXAME NO HISTÓRICO
              </Button>
              <Button
                to={RoutesEnum.PATIENTS_VIEW.replace(':patientId', patientId)}
                variant='link'
              >
                Ver histórico do paciente
              </Button>
            </>
          )
          : (
            <>
              <Button
                disabled={disabled}
                block
                size='sm'
                onClick={onSearch}
                isLoading={isLoading}
              >
                ATRIBUIR A UM PACIENTE
              </Button>
              <Button
                to={RoutesEnum.PATIENTS_CREATE}
                variant='link'
              >
                Criar um novo paciente
              </Button>
            </>
          )}
      </div>
    </Container>
  )
}

export default CardPatient
